import React, { useEffect, useState, useRef } from "react";

import Header from "../../../layout/Header";
import Subheader from "../../../layout/Subheader";
import OperationsMiddle from "./OperationsMiddle";
import OperationsFilter from "./OperationsFilter";
import OperationButtons from "./OperationButtons";
import OperationGrid from "./OperationsGrid";
import api from "../../../services/api";

import * as S from "./style";
import { useMessageBox } from "../../../context/MessageBox";
import { useNotification } from "../../../context/NotificationContext";
import { TOKEN_USER } from "../../../services/auth";
import Loading from "../../../components/Loading";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

export function DynamicReport() {
	const grid1Ref = useRef(null);
	const grid2Ref = useRef(null);
	const grid3Ref = useRef(null);
	const operationRef = useRef(null);
	const [windowSize, setWindowSize] = useState(window.innerWidth);
	const { id } = useParams();
	const [selectedProvider, setSelectedProvider] = useState("");
	const [providerInfo, setProviderInfo] = useState([]);
	const [proposeProps, setProposeProps] = useState({
		isPropose: false,
		origin: "",
	});
	const [intervalTime, setintervalTime] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [loader, setLoader] = useState(true);
	const [filterData, setFilterData] = useState([]);
	const [filterRenderData, setFilterRenderData] = useState([]);
	const [title, setTitle] = useState("Relatório Dinâmicos");
	const [updateContent, setUpdateContent] = useState(Date.now());
	const [grid1, setGrid1] = useState({});
	const [grid2, setGrid2] = useState({});
	const [grid3, setGrid3] = useState({});

const [selectedItems, setSelectedItems] = useState({
  grid1: new Set(),
  grid2: new Set(),
  grid3: new Set()
});

const [bulkSelectMode, setBulkSelectMode] = useState({
  grid1: false,
  grid2: false,
  grid3: false
});

	const [selectAll, setSelectAll] = useState({
	grid1: false,
	grid2: false,
	grid3: false
	});

	const [grid1Info, setGrid1Info] = useState({
		gridAlinhamento: "",
		gridAlturaGrid: "",
		gridInstrucaoSql: "",
		gridInstrucaoSqlTotalizador: "",
		gridTitulo: "",
		gridTituloAlinhamentoHorizontal: "",
		gridTituloAlinhamentoVertical: "",
		gridTituloCorFonte: "",
		gridTituloCorFundo: "",
		gridTituloFonteBold: false,
		gridTotalizador: "",
		gridVisivel: false,
	});
	const [grid2Info, setGrid2Info] = useState({
		gridAlinhamento: "",
		gridAlturaGrid: "",
		gridInstrucaoSql: "",
		gridInstrucaoSqlTotalizador: "",
		gridTitulo: "",
		gridTituloAlinhamentoHorizontal: "",
		gridTituloAlinhamentoVertical: "",
		gridTituloCorFonte: "",
		gridTituloCorFundo: "",
		gridTituloFonteBold: false,
		gridTotalizador: "",
		gridVisivel: false,
	});
	const [grid3Info, setGrid3Info] = useState({
		gridAlinhamento: "",
		gridAlturaGrid: "",
		gridInstrucaoSql: "",
		gridInstrucaoSqlTotalizador: "",
		gridTitulo: "",
		gridTituloAlinhamentoHorizontal: "",
		gridTituloAlinhamentoVertical: "",
		gridTituloCorFonte: "",
		gridTituloCorFundo: "",
		gridTituloFonteBold: false,
		gridTotalizador: "",
		gridVisivel: false,
	});
	const [loadingGrid, setLoadingGrid] = useState(false);
	const [validList, setValidList] = useState([]);
	const [avisosValidation, setAvisosValidations] = useState([]);
	const [valoresRespostas, setValoresRespostas] = useState([]);
	const [currentReport, setCurrentReport] = useState({});
	const [currentSelected, setCurrentSelected] = useState(0);
	const [canShowSelect, setCanShowSelect] = useState(true);
	const { setMessageData } = useMessageBox();
	const [selectedAnchor, setSelectedAnchor] = useState(null);

	const reloadPage = async (
		provider,
		origemParam = "",
		proposePropsParam = { isPropose: false, origin: "" }
	) => {
		setTimeout(() => {
			setSelectedProvider({ ...provider, origemProv: origemParam });
			setProviderInfo(provider);
			setProposeProps(proposePropsParam);
		}, 1);
	};

	
	const exportTable = async (type) => {
		setIsLoading(true);
		setLoadingGrid(true);
		try {
			let relatorio = {};

			let filtroPayload = [];
			let payload = {
				relatorioDinamicoId: currentSelected,
				filtros: [],
			};

			filterData.map((filtro) => {
				const currentFilter = {
					componenteResponse: valoresRespostas[filtro.ordem]
						? valoresRespostas[filtro.ordem].ancoraId != null &&
						  valoresRespostas[filtro.ordem].plataformaId != null
							? `${selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0};${
									selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0
							  }`
							: valoresRespostas[filtro.ordem]
						: filtro.componenteDefault,
					relatorioDinamicoFiltroId: filtro.relatorioDinamicoFiltroId,
				};
				filtroPayload.push(currentFilter);
			});

			payload.filtros = filtroPayload;

			if (type === "excel") {
				relatorio = await api.post(
					"RelatoriosDinamicos/GerarRelatorioDinamicoDownloadExcel",
					payload
				);
			} else if (type === "pdf") {
				relatorio = await api.post(
					"RelatoriosDinamicos/GerarRelatorioDinamicoDownloadPdf",
					payload
				);
			} else if (type === "csv") {
				relatorio = await api.post(
					"RelatoriosDinamicos/GerarRelatorioDinamicoDownloadCsv",
					payload
				);
			} else {
				relatorio = await api.post(
					"RelatoriosDinamicos/GerarRelatorioDinamicoDownloadTxt",
					payload
				);
			}

			if (!relatorio) {
				setIsLoading(false);
				setLoadingGrid(false);
				return;
			}

			if (relatorio?.data?.complemento?.mensagensBox?.length > 0) {
				setMessageData(relatorio?.data?.complemento?.mensagensBox);
			}

			if (relatorio.data.status !== "Sucesso") {
				if (relatorio.data.resposta) {
					if (relatorio.data.resposta.length > 0) {
						relatorio.data.resposta.forEach((element) => {
							toast.error(element.message);
						});
					}
				}
				setLoadingGrid(false);
				setIsLoading(false);
				return;
			}

			const a = document.createElement("a");
			a.href =
				"data:" +
				relatorio.data.resposta.contentType +
				";base64," +
				relatorio.data.resposta.fileContents;
			a.download = relatorio.data.resposta.fileDownloadName;
			a.click();
			setLoadingGrid(false);
			setIsLoading(false);
		} catch (error) {
		} finally {
			setLoadingGrid(false);
			setIsLoading(false);
		}
	};
		// Função atualizada para lidar com ambos os modos
			const handleCheckboxChange = (gridNumber, itemId, isChecked) => {
			const gridKey = `grid${gridNumber}`;
			
			if (bulkSelectMode[gridKey]) {
				// Modo "Marcar Todos" ativado
				const currentGrid = gridNumber === 1 ? grid1 : gridNumber === 2 ? grid2 : grid3;
				const allIds = new Set(
				currentGrid.linhas
					?.map(item => {
					const checkboxColumn = item.colunas?.find(col => 
						col.tipo.toLowerCase() === 'checkbox');
					return checkboxColumn?.valorInformacao;
					})
					.filter(id => id !== undefined)
				);
				
				setSelectedItems(prev => ({
				...prev,
				[gridKey]: isChecked ? allIds : new Set()
				}));
			} else {
				// Modo normal - seleção individual
				setSelectedItems(prev => {
				const newSelection = new Set(prev[gridKey] || []);
				if (isChecked) {
					newSelection.add(itemId);
				} else {
					newSelection.delete(itemId);
				}
				return {
					...prev,
					[gridKey]: newSelection
				};
				});
			}
			};

			// Função para alternar o modo bulk
			const toggleBulkSelectMode = (gridNumber) => {
			const gridKey = `grid${gridNumber}`;
			
			// Apenas alterna o estado do modo bulk, sem limpar seleção
			setBulkSelectMode(prev => ({
				...prev,
				[gridKey]: !prev[gridKey]
			}));
			};

		// Função para selecionar/deselecionar todos os itens de uma grid
		const handleSelectAll = (gridNumber) => {
		setSelectedItems(prev => {
			const gridKey = `grid${gridNumber}`;
			const currentGrid = gridNumber === 1 ? grid1 : gridNumber === 2 ? grid2 : grid3;
			const allIds = new Set(currentGrid.linhas?.map(item => {
			// Encontra a coluna do checkbox
			const checkboxColumn = item.colunas.find(col => col.tipo.toLowerCase() === 'checkbox');
			return checkboxColumn?.valorInformacao;
			}).filter(id => id !== undefined) || []);

			return {
			...prev,
			[gridKey]: prev[gridKey].size === allIds.size ? new Set() : new Set(allIds)
			};
		});
		};


		const processSelectedItems = async (array) => {
		const gridKey = `grid${1}`;
		const itemsToProcess = array.filter(item => item && item !== 0 && item !== '0'); //

		console.log("Processando itens da grid:", itemsToProcess);

		if (itemsToProcess.length === 0) {
			toast.warning(`Nenhum item selecionado na grid ${gridNumber} para processar`);
			return;
		}

		setIsLoading(true);
		try {
			const requisicoes = itemsToProcess.map(id => ({
			AcaoInternaId: 5, 
			Parametros: `0;${id}`
			}));

			const response = await api.post('/AcoesInternas/ExecutarEmLote', requisicoes);
				if (response.data.status === "Sucesso") {
					const successCount = response.data.resposta.filter(
					item => item.executadoComSucesso
				).length;
				
				if (successCount === itemsToProcess.length) {
					toast.success(`Todos os ${successCount} itens processados com sucesso!`);
				} else {
					toast.warning(
					`${successCount} de ${itemsToProcess.length} itens processados. ` +
					`Verifique os itens não processados.`
					);
				}

					// Limpa apenas os itens processados
					setSelectedItems(prev => {
						const newSet = new Set(prev[gridKey]);
						itemsToProcess.forEach(id => newSet.delete(id));
						return {
						...prev,
						[gridKey]: newSet
						};
					});

					await generateDinamicReport();
				} else {
				// Trata erros específicos da API
				const errorMessages = response.data.resposta
					.filter(item => !item.executadoComSucesso)
					.map(item => item.mensagemRetornoExecucao || "Erro desconhecido");
				
				toast.error(
					`Erros no processamento: ${errorMessages.join(' | ')}`,
					{ autoClose: 10000 }
				);
			}
			} catch (error) {
			console.error("Erro na requisição:", error);
			toast.error(
				`Falha na comunicação com o servidor: ${error.message}`,
				{ autoClose: 8000 }
			);
			} finally {
			setIsLoading(false);
			}
		};

	const generateDinamicReport = async () => {
		setIsLoading(true);
		setLoadingGrid(true);
		setGrid1({});
		setGrid2({});
		setGrid3({});
		try {
			let filtroPayload = [];
			let payload = {
				relatorioDinamicoId: currentSelected,
				filtros: [],
			};

			filterData.map((filtro) => {
				const currentFilter = {
					componenteResponse: valoresRespostas[filtro.ordem]
						? valoresRespostas[filtro.ordem].ancoraId != null &&
						  valoresRespostas[filtro.ordem].plataformaId != null
							? `${selectedAnchor.ancoraId ? selectedAnchor.ancoraId : 0};${
									selectedAnchor.plataformaId ? selectedAnchor.plataformaId : 0
							  }`
							: valoresRespostas[filtro.ordem]
						: filtro.componenteDefault,
					relatorioDinamicoFiltroId: filtro.relatorioDinamicoFiltroId,
				};
				filtroPayload.push(currentFilter);
			});

			payload.filtros = filtroPayload;
			const grids = await api.post(
				"RelatoriosDinamicos/GerarRelatorioDinamico",
				payload
			);
			//debugger
			if (grids?.data?.complemento?.mensagensBox?.length > 0) {
				setMessageData(grids?.data?.complemento?.mensagensBox);
			}

			if (grids.data.status !== "Sucesso") {
				if (grids.data.resposta) {
					if (grids.data.resposta.length > 0) {
						grids.data.resposta.forEach((element) => {
							toast.error(element.message);
						});
					}
				}
			} else {
				if (
					grids.data.resposta.grid1.cabecalho.length === 0 &&
					grids.data.resposta.grid2.cabecalho.length === 0 &&
					grids.data.resposta.grid3.cabecalho.length === 0
				) {
					toast.error(
						"Sem dados para o relatório. Altere o filtros e gere o relatório novamente"
					);
				} else {
					if(grids.data.resposta.grid1.cabecalho.length === 0) {
						setGrid1({});
						setGrid1Info({
							gridAlinhamento: "",
							gridAlturaGrid: "",
							gridInstrucaoSql: "",
							gridInstrucaoSqlTotalizador: "",
							gridTitulo: "",
							gridTituloAlinhamentoHorizontal: "",
							gridTituloAlinhamentoVertical: "",
							gridTituloCorFonte: "",
							gridTituloCorFundo: "",
							gridTituloFonteBold: false,
							gridTotalizador: "",
							gridVisivel: false,
						});
					} else {
						console.log(grids.data.resposta.grid1)
						setGrid1(grids.data.resposta.grid1);
						setGrid1Info({
							gridAlinhamento:
								grids.data.resposta.relatorioDinamico.grid1Alinhamento,
							gridAlturaGrid: grids.data.resposta.relatorioDinamico.grid1AlturaGrid,
							gridInstrucaoSql:
								grids.data.resposta.relatorioDinamico.grid1InstrucaoSql,
							gridInstrucaoSqlTotalizador:
								grids.data.resposta.relatorioDinamico.grid1InstrucaoSqlTotalizador,
							gridTitulo: grids.data.resposta.relatorioDinamico.grid1Titulo,
							gridTituloAlinhamentoHorizontal:
								grids.data.resposta.relatorioDinamico
									.grid1TituloAlinhamentoHorizontal,
							gridTituloAlinhamentoVertical:
								grids.data.resposta.relatorioDinamico
									.grid1TituloAlinhamentoVertical,
							gridTituloCorFonte:
								grids.data.resposta.relatorioDinamico.grid1TituloCorFonte,
							gridTituloCorFundo:
								grids.data.resposta.relatorioDinamico.grid1TituloCorFundo,
							gridTituloFonteBold:
								grids.data.resposta.relatorioDinamico.grid1TituloFonteBold,
							gridTotalizador:
								grids.data.resposta.relatorioDinamico.grid1Totalizador,
							gridVisivel: grids.data.resposta.relatorioDinamico.grid1Visivel,
						});
					}

					if(grids.data.resposta.grid2.cabecalho.length === 0) {
						setGrid2({});
						setGrid2Info({
							gridAlinhamento: "",
							gridAlturaGrid: "",
							gridInstrucaoSql: "",
							gridInstrucaoSqlTotalizador: "",
							gridTitulo: "",
							gridTituloAlinhamentoHorizontal: "",
							gridTituloAlinhamentoVertical: "",
							gridTituloCorFonte: "",
							gridTituloCorFundo: "",
							gridTituloFonteBold: false,
							gridTotalizador: "",
							gridVisivel: false,
						});
					} else {
						setGrid2(grids.data.resposta.grid2);
						setGrid2Info({
							gridAlinhamento:
								grids.data.resposta.relatorioDinamico.grid2Alinhamento,
							gridAlturaGrid: grids.data.resposta.relatorioDinamico.grid2AlturaGrid,
							gridInstrucaoSql:
								grids.data.resposta.relatorioDinamico.grid2InstrucaoSql,
							gridInstrucaoSqlTotalizador:
								grids.data.resposta.relatorioDinamico.grid2InstrucaoSqlTotalizador,
							gridTitulo: grids.data.resposta.relatorioDinamico.grid2Titulo,
							gridTituloAlinhamentoHorizontal:
								grids.data.resposta.relatorioDinamico
									.grid2TituloAlinhamentoHorizontal,
							gridTituloAlinhamentoVertical:
								grids.data.resposta.relatorioDinamico
									.grid2TituloAlinhamentoVertical,
							gridTituloCorFonte:
								grids.data.resposta.relatorioDinamico.grid2TituloCorFonte,
							gridTituloCorFundo:
								grids.data.resposta.relatorioDinamico.grid2TituloCorFundo,
							gridTituloFonteBold:
								grids.data.resposta.relatorioDinamico.grid2TituloFonteBold,
							gridTotalizador:
								grids.data.resposta.relatorioDinamico.grid2Totalizador,
							gridVisivel: grids.data.resposta.relatorioDinamico.grid2Visivel,
						});
					}

					if(grids.data.resposta.grid3.cabecalho.length === 0) {
						setGrid3({});
						setGrid3Info({
							gridAlinhamento: "",
							gridAlturaGrid: "",
							gridInstrucaoSql: "",
							gridInstrucaoSqlTotalizador: "",
							gridTitulo: "",
							gridTituloAlinhamentoHorizontal: "",
							gridTituloAlinhamentoVertical: "",
							gridTituloCorFonte: "",
							gridTituloCorFundo: "",
							gridTituloFonteBold: false,
							gridTotalizador: "",
							gridVisivel: false,
						});
					} else {
						setGrid3(grids.data.resposta.grid3);
						setGrid3Info({
							gridAlinhamento:
								grids.data.resposta.relatorioDinamico.grid3Alinhamento,
							gridAlturaGrid: grids.data.resposta.relatorioDinamico.grid3AlturaGrid,
							gridInstrucaoSql:
								grids.data.resposta.relatorioDinamico.grid3InstrucaoSql,
							gridInstrucaoSqlTotalizador:
								grids.data.resposta.relatorioDinamico.grid3InstrucaoSqlTotalizador,
							gridTitulo: grids.data.resposta.relatorioDinamico.grid3Titulo,
							gridTituloAlinhamentoHorizontal:
								grids.data.resposta.relatorioDinamico
									.grid3TituloAlinhamentoHorizontal,
							gridTituloAlinhamentoVertical:
								grids.data.resposta.relatorioDinamico
									.grid3TituloAlinhamentoVertical,
							gridTituloCorFonte:
								grids.data.resposta.relatorioDinamico.grid3TituloCorFonte,
							gridTituloCorFundo:
								grids.data.resposta.relatorioDinamico.grid3TituloCorFundo,
							gridTituloFonteBold:
								grids.data.resposta.relatorioDinamico.grid3TituloFonteBold,
							gridTotalizador:
								grids.data.resposta.relatorioDinamico.grid3Totalizador,
							gridVisivel: grids.data.resposta.relatorioDinamico.grid3Visivel,
						});
					}

					const viewportHeight = window.innerHeight;
					let topElement = 0;
					if (grid1Ref) {
						topElement = grid1Ref.current.offsetHeight;
						window.scrollTo(0, topElement - viewportHeight / 2);
					} else if (grid2Ref) {
						topElement = grid2Ref.current.offsetHeight;
						window.scrollTo(0, topElement - viewportHeight / 2);
					} else if (grid3Ref) {
						topElement = grid3Ref.current.offsetHeight;
						window.scrollTo(0, topElement - viewportHeight / 2);
					}
				}
			}
		} catch (err) {
			toast.error(err.message);
		} finally {
			setIsLoading(false);
			setLoadingGrid(false);
		}
	};

	useEffect(() => {
		if (intervalTime > 0) {
			const interval = setInterval(
				() => setUpdateContent(Date.now()),
				intervalTime
			);
			return () => {
				clearInterval(interval);
			};
		}
	}, [intervalTime]);

	useEffect(() => {
		isLoading
			? localStorage.setItem("isLoading", "true")
			: localStorage.setItem("isLoading", "false");
		setTimeout(() => {
			setLoader(localStorage.getItem("isLoading") === "true");
		}, 200);
	}, [isLoading]);

	useEffect(async () => {
		const handleWindowResize = () => {
			setWindowSize(window.innerWidth);
		};

		window.addEventListener("resize", handleWindowResize);

		setintervalTime(
			Number(
				JSON.parse(
					sessionStorage.getItem("@Capittale-Web-Setting")
				)?.configuracoesAmbienteWeb?.find((el) => el.parametroId === 40)
					?.valor ?? 0
			) *
				1000 *
				60
		);
	}, []);

	return (
		<S.Root>
			<Header />
			<Subheader title={title} back="/app/home" />
			<S.Content
				style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}
			>
				{canShowSelect && (
					<div
						style={{
							width: "100%",
							margin: "10px 0px",
							height: "100%",
							display: "flex",
						}}
					>
						<OperationsMiddle
							setFilterData={setFilterData}
							setTitle={setTitle}
							setIsLoading={setIsLoading}
							isLoading={isLoading}
							idDynamic={id}
							setGrid1={setGrid1}
							setGrid2={setGrid2}
							setGrid3={setGrid3}
							setGrid1Info={setGrid1Info}
							setGrid2Info={setGrid2Info}
							setGrid3Info={setGrid3Info}
							setFilterRenderData={setFilterRenderData}
							setCurrentReport={setCurrentReport}
							setCurrentSelected={setCurrentSelected}
							setCanShowSelect={setCanShowSelect}
						/>
					</div>
				)}
				{filterData.length > 0 && (
					<>
						<div
							ref={operationRef}
							style={{
								width: "100%",
								margin: "10px 0px",
								padding: "0px 20px 20px 20px",
								height: "100%",
								border: "2px solid #ddd",
								borderRadius: "8px",
								backgroundColor: "#eee",
							}}
						>
							<OperationsFilter
								filterData={filterData}
								setIsLoading={setIsLoading}
								isLoading={isLoading}
								setValidList={setValidList}
								setAvisosValidations={setAvisosValidations}
								setValoresRespostas={setValoresRespostas}
								valoresRespostas={valoresRespostas}
								filterRenderData={filterRenderData}
								selectedAnchor={selectedAnchor}
								setSelectedAnchor={setSelectedAnchor}
							/>
						</div>
					</>
				)}
				{currentSelected !== 0 && (
					<div
						style={{
							width: "100%",
							margin: "10px 0px",
							height: "100%",
						}}
					>
						{loadingGrid ? (
							<Loading />
						) : (
							<OperationButtons
								isLoading={isLoading}
								exportTable={exportTable}
								generateDinamicReport={generateDinamicReport}
								currentReport={currentReport}
  								selectedItems={Array.from(selectedItems.grid1 || [])}
								processSelectedItems={processSelectedItems}
								bulkSelectMode={bulkSelectMode}
  								toggleBulkSelectMode={toggleBulkSelectMode}
							/>
						)}
					</div>
				)}

				{(grid1?.cabecalho?.length > 0 ||
					grid2?.cabecalho?.length > 0 ||
					grid3?.cabecalho?.length > 0) && (
					<div
						id="divGridPai"
						style={{
							width: "100%",
							height: "100%",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						
						{grid1?.cabecalho?.length > 0 && (
							<div
								id="divGrid1Filho"
								ref={grid1Ref}
								style={{
									width: "100%",
									height:
										grid1Info.gridAlturaGrid > 0
											? grid1Info.gridAlturaGrid
											: "495px",
									border: "2px solid #ddd",
									borderRadius: "8px",
									backgroundColor: "#eee",
									margin: "10px 0px",
									padding: "20px 0px 20px 20px",
									display: "flex",
									justifyContent:
										grid1Info.gridAlinhamento === "right"
											? "end"
											: grid1Info.gridAlinhamento === "left"
											? "start"
											: "center",
								}}
							>
								<div
									id="divGrid1Neto"
									style={{
										overflow: "auto",
										margin: "0px",
										width: "fit-content",
									}}
								>
									<OperationGrid
										key={`grid-${1}-${selectedItems[`grid${1}`]?.size || 0}`}
										gridCabecalho={grid1.cabecalho}
										gridBody={grid1.linhas}
										gridTotalizador={grid1.totalizador}
										gridInfo={grid1Info}
										setLoadingGrid={setLoadingGrid}
  										selectedItems={Array.from(selectedItems.grid1 || [])}
  										onCheckboxChange={handleCheckboxChange}
										gridNumber={1}
									/>
								</div>
							</div>
						)}
						{grid2?.cabecalho?.length > 0 && (
							<div
								id="divGrid2Filho"
								ref={grid2Ref}
								style={{
									width: "100%",
									height:
										grid2Info.gridAlturaGrid > 0
											? grid2Info.gridAlturaGrid
											: "495px",
									border: "2px solid #ddd",
									borderRadius: "8px",
									backgroundColor: "#eee",
									margin: "10px 0px",
									padding: "20px 0px 20px 20px",
									display: "flex",
									justifyContent:
										grid2Info.gridAlinhamento === "right"
											? "end"
											: grid2Info.gridAlinhamento === "left"
											? "start"
											: "center",
								}}
							>
								<div
									id="divGrid2Neto"
									style={{
										overflow: "auto",
										margin: "0px",
										width: "fit-content",
									}}
								>
									<OperationGrid
										gridCabecalho={grid2.cabecalho}
										gridBody={grid2.linhas}
										gridTotalizador={grid2.totalizador}
										gridInfo={grid2Info}
										setLoadingGrid={setLoadingGrid}
									/>
								</div>
							</div>
						)}
						{grid3?.cabecalho?.length > 0 && (
							<div
								id="divGrid3Filho"
								ref={grid3Ref}
								style={{
									width: "100%",
									height:
										grid3Info.gridAlturaGrid > 0
											? grid3Info.gridAlturaGrid
											: "495px",
									border: "2px solid #ddd",
									borderRadius: "8px",
									backgroundColor: "#eee",
									margin: "10px 0px",
									padding: "20px 0px 20px 20px",
									display: "flex",
									justifyContent:
										grid3Info.gridAlinhamento === "right"
											? "end"
											: grid3Info.gridAlinhamento === "left"
											? "start"
											: "center",
								}}
							>
								<div
									id="divGrid3Neto"
									style={{
										overflow: "auto",
										margin: "0px",
										width: "fit-content",
									}}
								>
									<OperationGrid
										gridCabecalho={grid3.cabecalho}
										gridBody={grid3.linhas}
										gridTotalizador={grid3.totalizador}
										gridInfo={grid3Info}
										setLoadingGrid={setLoadingGrid}
									/>
								</div>
							</div>
						)}
					</div>
				)}
			</S.Content>
		</S.Root>
	);
}
